export function buildAgingQuery(criteria, { page, limit, search }) {
  const p = new URLSearchParams();
  p.set('aging_date', criteria.agingDate);
  p.set('group_by', criteria.groupBy);
  const ints = [criteria.interval1, criteria.interval2, criteria.interval3, criteria.interval4]
    .map((x) => parseInt(x, 10))
    .filter((n) => n > 0);
  p.set('intervals', ints.length ? ints.join(',') : '30,60,90,120');

  if (criteria.postingFrom) p.set('posting_from', criteria.postingFrom);
  if (criteria.postingTo) p.set('posting_to', criteria.postingTo);
  if (criteria.dueFrom) p.set('due_from', criteria.dueFrom);
  if (criteria.dueTo) p.set('due_to', criteria.dueTo);
  if (criteria.docFrom) p.set('doc_from', criteria.docFrom);
  if (criteria.docTo) p.set('doc_to', criteria.docTo);
  if (criteria.codeFrom) p.set('code_from', criteria.codeFrom);
  if (criteria.codeTo) p.set('code_to', criteria.codeTo);
  if (criteria.displayZero) p.set('display_zero', '1');
  if (criteria.ignoreFutureRemit) p.set('ignore_future_remit', '1');

  p.set('page', String(page));
  p.set('limit', String(limit));
  if (search) p.set('search', search);
  return p.toString();
}

/** @param {number[]} intervals */
export function agingColumnLabels(intervals) {
  if (!intervals || !intervals.length) {
    return [
      { key: 'current', label: 'Current' },
      { key: 'b1', label: '1–30' },
      { key: 'b2', label: '31–60' },
      { key: 'b3', label: '61–90' },
      { key: 'b4', label: '91–120' },
      { key: 'over', label: '121+' },
    ];
  }
  const h = [{ key: 'current', label: 'Current' }];
  for (let i = 0; i < intervals.length; i += 1) {
    const lo = i === 0 ? 1 : intervals[i - 1] + 1;
    const hi = intervals[i];
    h.push({ key: `b${i + 1}`, label: `${lo}–${hi}` });
  }
  const last = intervals[intervals.length - 1];
  h.push({ key: 'over', label: `${last + 1}+` });
  return h;
}
